import { Select } from "antd";
import { DropdownSuffix } from "icons";
import { useState } from "react";

export const Dropdown = ({ value, handleSelectOption, options }) => {
  const [open, setOpen] = useState(false);

  return (
    <Select
      open={open}
      onDropdownVisibleChange={setOpen}
      showSearch
      onChange={handleSelectOption}
      filterOption={(
        input,
        option, // 👈 filter logic
      ) => (option?.label ?? "").toLowerCase().includes(input.toLowerCase())}
      // defaultValue={employees[0]?.value}
      style={{ width: "100%", height: "100%" }}
      value={value}
      options={options}
      suffixIcon={<DropdownSuffix />}
      placeholder="Select"
    />
  );
};
